export enum UsersPaths {
  GENERAL_INFO = "/general-info",
  PAYMENTS = "/payments",
  LOTS = "/lots",
  PROTOCOLS = "/protocols",
}
